import { render, staticRenderFns } from "./weather.vue?vue&type=template&id=24d538c6&scoped=true&"
import script from "./weather.vue?vue&type=script&lang=js&"
export * from "./weather.vue?vue&type=script&lang=js&"
import style0 from "./weather.vue?vue&type=style&index=0&id=24d538c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d538c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d538c6')) {
      api.createRecord('24d538c6', component.options)
    } else {
      api.reload('24d538c6', component.options)
    }
    module.hot.accept("./weather.vue?vue&type=template&id=24d538c6&scoped=true&", function () {
      api.rerender('24d538c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/weather.vue"
export default component.exports